import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import GoogleMapReact from 'google-map-react';

const DEFAULT_LATITUDE = -22.26418850116244;
const DEFAULT_LONGITUDE = 166.44395793613953;
const DEFAULT_ZOOM = 15;

const Map = props => {
  const { alternateName, geo } = props;

  const router = useRouter();

  const { latitude: lat, longitude: lng } = geo || {};

  const [position, setPosition] = useState({ lat, lng });

  const { locale } = router;

  const createMapOptions = map => {
    return {
      fullscreenControlOptions: {
        position: map.ControlPosition.RIGHT_TOP,
      },
      mapTypeControl: false,
      panControl: false,
      rotateControl: false,
      streetViewControl: false,
      zoomControlOptions: {
        position: map.ControlPosition.LEFT_TOP,
      },
    };
  };

  const renderMarker = api => {
    const { map, maps } = api;
    return new maps.Marker({
      position: { lat, lng },
      map,
      title: alternateName,
    });
  };

  useEffect(() => {
    setPosition({ lat, lng });
  }, [geo]);

  if (lat === undefined || lng === undefined) return null;

  return (
    <div
      style={{
        height: '35vh',
        width: '100%',
      }}
    >
      <GoogleMapReact
        bootstrapURLKeys={{
          key: process.env.GOOGLE_MAP_API_KEY,
          language: locale,
        }}
        center={position}
        zoom={DEFAULT_ZOOM}
        options={createMapOptions}
        onGoogleApiLoaded={renderMarker}
        yesIWantToUseGoogleMapApiInternals
      />
    </div>
  );
};

export default Map;
